import { appRouteConfigs } from '../routes/AppRouteConfig';

interface MenuItem {
	to: string;
	label: string;
	roles: string[];
	departmentCodes?: string[];
}
export interface DropdownLink {
	title: string;
	id: string;
	items: MenuItem[];
}

const shouldSortMenuItems = (menu: DropdownLink) => menu.id === 'reference';
const sortMenuItems = (items: MenuItem[]) => [...items].sort((a, b) => a.label.localeCompare(b.label));

const menuMap = new Map<string, DropdownLink>();

appRouteConfigs.forEach(route => {
	if (!route.menu) {
		return;
	}

	const existingMenu = menuMap.get(route.menu.id);
	const item: MenuItem = {
		to: route.path,
		label: route.menu.label,
		roles: route.roles,
		departmentCodes: route.departmentCodes,
	};

	if (existingMenu) {
		existingMenu.items.push(item);
		return;
	}

	menuMap.set(route.menu.id, {
		id: route.menu.id,
		title: route.menu.title,
		items: [item],
	});
});

export const dropdownLinks: DropdownLink[] = Array.from(menuMap.values())
	.map(menu => shouldSortMenuItems(menu) ? { ...menu, items: sortMenuItems(menu.items) } : menu);
